import React, { useEffect } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import "../assets/css/venobox.css";
import "../assets/css/style.css";

const Contact = () => { return ( 
    <div>
      <NavBar />
      <main id="main">	
        <section id="contact" className="innerPage">
          <div className="container">
            <div className="section-title">
              <h2> ഞങ്ങളുമായി ബന്ധപ്പെടുക </h2>
            </div>
            <div className="row">
             
              <div className="col-md-6 d-flex">
                <div style={{width:'100%'}}>
                  <h6>RBI റീട്ടെയിൽ ഡയറക്റ്റ് സപ്പോർട്ട് </h6>
                  {/* <p>
                    <i className="ri-phone-line"></i>{" "}
                    <a href=" ഫോൺ:1800 267  7955">1800 267 7955</a>
                  </p> */}
                  <p>
                    <i className="ri-phone-line"></i>{" "}
                    <i class="ri-arrow-right-up-line" style={{color: 'limegreen', marginLeft: '-4px'}}></i>
                    <a href="tel:1800 267  7955" title="Out-Bound Number">1800 267 7955</a>
                  </p>
                  <p>
                    <i class="ri-phone-line"></i> 
                    <i class="ri-arrow-left-down-line" style={{color: 'red' , marginLeft:'-4px'}}></i>
                    <a href="tel:+91-22-61546335" title="In-Bound Number">+91-22-61546335</a>
                  </p>
                  <p>
                    <i className="ri-mail-line"></i>{" "}
                    <a href="mailto:support@rbiretaildirect.org.in">
                      support@rbiretaildirect.org.in
                    </a>
                  </p>
                  <p>
                    <i className="ri-time-line"></i>{" "}
                    <a style={{color:'#000'}}> രാവിലെ 10 മുതൽ വൈകിട്ട് 6 വരെ (തിങ്കൾ - ശനി) </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer footerClass="footerFixed" />
    </div>
   )};export default Contact;
